import "../../styles/OnboardingScreen2.css";
import screen2Img from "../../assets/onboarding/screen2.png";

export default function OnboardingScreen2() {
  return (
    <div className="ob2">
      <div className="ob2Text">
        <h1>
          Просто опиши,
          
          що тобі
          
          подобається
        </h1>

        <p>
          Напиши стиль, смак, настрій
          <br />
          або ситуацію — наприклад:
          <br />
          “щось легке”, “хочу IPA”,
          
          “пиво на вечір”.
        </p>

        <p className="ob2Highlight">
          Ми <span>підберемо варіанти</span>,
          <br />
          які тобі підійдуть.
        </p>
      </div>

      <div className="ob2ImageWrap">
        <img src={screen2Img} alt="Chat recommendations" />
      </div>
    </div>
  );
}